import Vue from 'vue'
import { Message } from 'element-ui';
import Router from 'vue-router'
import IndexPage from '@/components/IndexPage'
import Login from '@/components/Login'
import OrderList from '@/components/OrderList'
import ShopList from '@/components/ShopList'
import ImgSort from '@/components/ImgSort'
import IpManage from '@/components/IpManage'
import IpList from '@/components/IpList'
import CategoryList from '@/components/CategoryList'
import GoodSku from '@/components/GoodSku';
import GoodSpu from '@/components/GoodSpu'
import AuthorManage from '@/components/AuthorManage'
import TagManage from '@/components/TagManage'
import BuyManage from '@/components/BuyManage'
import Authorization from '@/components/Authorization'
import SettleManager from '@/components/SettleManager'
import OrderConfirm from '@/components/OrderConfirm'
import Address from '@/components/Address'
import AddressEdit from '@/components/AddressEdit'
import ChangePassword from '@/components/ChangePassword'
import MyIPOrder from '@/components/MyIPOrder'
import MyIpManage from '@/components/MyIpManage'
import SupplyInfo from '@/components/SupplyInfo'
import CertificateInfo from '@/components/CertificateInfo'
import ProducerAudit from '@/components/ProducerAudit'
import ClaimAudit from '@/components/ClaimAudit'
import IpAudit from '@/components/IpAudit'
import ProducerRegister from '@/components/producerRegister/ProducerRegister'
import WithdrawRecord from '@/components/WithdrawRecord'
import AuthorList from '@/components/AuthorList'
import AuthorAllDesign from '@/components/AuthorAllDesign'


Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'IndexPage',
      component: IndexPage,
      children: [
        {
          path: '/orderlist',
          name: 'OrderList',
          component: OrderList,
          meta: { title: "订单管理" }
        }, {
          path: '/shoplist',
          name: 'ShopList',
          component: ShopList,
          meta: { title: "店铺管理" }
        }, {
          path: '/imgsort',
          name: 'ImgSort',
          component: ImgSort,
          meta: { title: "图案分类管理" }
        },
        {
          path: '/ipManage',
          name: 'IpManage',
          component: IpManage,
          meta: { title: '作品管理' }
        },
        {
          path: '/authorManage',
          name: 'authorManage',
          component: AuthorManage,
          meta: { title: '生产者管理' }
        },
        {
          path: '/tagManage',
          name: 'TagManage',
          component: TagManage,
          meta: { title: '标签管理' }
        },
        {
          path: '/buyManage',
          name: 'BuyManage',
          component: BuyManage,
          meta: { title: 'IP管理' }
        },
        {
          path: '/orderConfirm',
          name: 'OrderConfirm',
          component: OrderConfirm,
          meta: { title: '确认订单' }
        },
        {
          path: '/address',
          name: 'Address',
          component: Address,
          meta: { title: '选择地址' }
        },
        {
          path: '/addressEdit',
          name: 'AddressEdit',
          component: AddressEdit,
          meta: { title: '编辑地址' }
        },
        {
          path: '/iplist',
          name: 'IpList',
          component: IpList,
          meta: { title: 'IP库浏览' }
        },
        {
          path: '/authorization',
          name: 'Authorization',
          component: Authorization,
          meta: { title: '授权管理' }
        },
        {
          path: '/settleManager',
          name: 'SettleManager',
          component: SettleManager,
          meta: { title: '入驻管理' }
        },
        {
          path: '/categorylist',
          name: 'CategoryList',
          component: CategoryList,
          meta: { title: '商品分类管理' }
        },
        {
          path: '/goodsku',
          name: 'GoodSku',
          component: GoodSku,
          meta: { title: '商品SKU管理' }
        },
        {
          path: '/goodspu',
          name: 'GoodSpu',
          component: GoodSpu,
          meta: { title: '商品SPU管理' }
        },
        {
          path: '/changePassword',
          name: 'ChangePassword',
          component: ChangePassword,
          meta: { title: '修改密码' }
        },
        {
          path: '/myIPOrder',
          name: 'MyIPOrder',
          component: MyIPOrder,
          meta: { title: '我的作品订单' }
        },
        {
          path: '/myIpManage',
          name: 'MyIpManage',
          component: MyIpManage,
          meta: { title: '我的作品' }
        },
        {
          path: '/supplyInfo',
          name: 'SupplyInfo',
          component: SupplyInfo,
          meta: { title: '完善基本资料' }
        },
        {
          path: '/certificateInfo',
          name: 'CertificateInfo',
          component: CertificateInfo,
          meta: { title: '完善认证资料' }
        },
        {
          path: '/producerAudit',
          name: 'ProducerAudit',
          component: ProducerAudit,
          meta: { title: '生产者认证审核' }
        },
        {
          path: '/ipAudit',
          name: 'IpAudit',
          component: IpAudit,
          meta: { title: 'IP内容审核' }
        },
        {
          path: '/claimAudit',
          name: 'ClaimAudit',
          component: ClaimAudit,
          meta: { title: '创作者审核' }
        },
        {
          path: '/withdrawRecord',
          name: 'WithdrawRecord',
          component: WithdrawRecord,
          meta: { title: '提现记录' }
        },
        {
          path: '/authorList',
          name: 'AuthorList',
          component: AuthorList,
          meta: { title: 'IP创作者' }
        },
        {
          path: '/authorAllDesign',
          name: 'AuthorAllDesign',
          component: AuthorAllDesign,
          meta: { title: '作者全部IP' }
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/producerRegister',
      name: 'ProducerRegister',
      component: ProducerRegister
    }
  ]
})
router.beforeEach((to, from, next) => {
  // ip生产者未审核通过的，只能访问完善资料、认证资料和修改密码
  let canVisitArr = ['SupplyInfo', 'CertificateInfo', 'ChangePassword',  'IndexPage']
  let roleId = localStorage.getItem('roleId')
  let checkStatus = localStorage.getItem('checkStatus')
  if (roleId == 5 && !canVisitArr.includes(to.name)) {
    // 审核通过
    if (checkStatus == 1) {
      next(true)
    } else {
      next(false)
      Message.error('审核未通过，不能访问其他功能');
    }
  } else {
    next(true)
  }
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js